'use strict';

angular.module('app.home.kpi')
    .directive('homeKpiDirective', function () {
        return {
            controller: 'HomeKPICtrl',
            templateUrl: 'app/home/homeKPI/homeKPI.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })